<template>
  <div class="Loglist">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>操作日志
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div class="search-box" style="background-color:#fff;margin-bottom: 20px;">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">用户账号:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="admin_user" size="small"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">操作日期:</div>
          </el-col>
          <el-col :span="4">
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd"
              v-model="time"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-col>
          <el-col :span="6" align="right" style="margin-left:100px;">
            <button @click="loadData()" style="margin-right: 20px" class="filtrate_seek_sousuo1">搜索</button>
            <button @click="clear()" class="filtrate_seek_sousuo1">清空</button>
          </el-col>
        </el-row>
      </div>

      <div class="form-title" style="display:flex">
        <div>
          <i class="fas fa-bars"></i>
        </div>
        <div style="float: left;line-height: 46px;padding-left: 10px;">数据列表</div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="编号" prop="id" width="100" align="center"></el-table-column>
          <el-table-column label="账号" prop="username" width="200" align="center"></el-table-column>
          <el-table-column label="操作日期" prop="date" width="200" align="center"></el-table-column>
          <el-table-column prop="str" label="操作记录" width="300" align="center"></el-table-column>
          <el-table-column prop="address" label="操作" width="200" align="center">
            <template slot-scope="scope">
              <div class="clear">
                <div>
                  <button class="btn2" @click="del(scope.row.id)">删除</button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pager">
          <el-row>
            <el-col>
              <el-pagination
                style="text-align:center"
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="30"
                @current-change="setPage"
              ></el-pagination>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      username: "",
      token: "",
      admin_user: null,
      category: null,
      categorys: [],
      brand: null,
      brands: [],
      tableData: [],
      multipleSelection: [],
      total: 0,
      currrent_page: 1,
      selectAll: false,
      checked: [],
      idString: "",
      resType: 0,
      time: ""
    };
  },
  mounted() {
    //
  },
  created() {
    this.$store.state.leftTitle = "操作日志";
    this.$store.state.topActiveId = 6;
    this.token = this.$cookies.get("token");
    this.username = this.$cookies.get("username");
    this.loadData();
  },
  methods: {
    //
    clear() {
      this.admin_user = "";
      this.time = "";
      this.loadData();
    },
    selectAllFn(v) {
      this.$refs.multipleTable.toggleAllSelection();
    },
    del(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/del_log", {
              params: {
                username: this.username,
                token: this.token,
                id: id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$notify({
                  title: "日志已删除",
                  type: "success"
                });
                this.loadData();
              }else if(res.data.code == '403'){
                this.$message.error(res.data.msg); 
              } 
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    loadData() {
      this.axios
        .get(this.serve + "/admin/get_admin_log", {
          params: {
            username: this.username,
            token: this.token,
            page: this.currrent_page,
            admin_user: this.admin_user,
            time: this.time
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.total = res.data.data.page_num;
            this.tableData = [];
            for (var key in res.data.data) {
              if (res.data.data[key].username) {
                this.tableData.push(res.data.data[key]);
              }
            }
          } else {
            if(res.data.msg == "无权访问"){
              this.role = false
            }
            this.tableData = [];
            this.total = 0;
          }
        });
    },
    handleSelectionChange(v) {
      this.idString = "";
      var tmpString = "";
      for (var item of v) {
        if (tmpString == "") {
          tmpString = item.id;
        } else {
          tmpString = tmpString + "," + item.id;
        }
      }
      this.idString = tmpString;
    },
    setPage(v) {
      this.currrent_page = v;
      this.loadData();
      this.selectAll = false;
    },
    setSelling(v, id) {
      this.axios
        .get(this.serve + "/admin/update_product_selling", {
          params: {
            username: "11111111",
            token: "a88d8ace95b88ebcc85cfcde418cb046",
            id: id,
            selling: v
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            if (v == 0) {
              var str = "下架";
            } else {
              var str = "上架";
            }
            this.$notify({
              title: "商品已" + str,
              type: "success"
            });
          }
        });
    }
  }
};
</script>
<style lang="scss">
.Loglist {
  .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .form-title {
    display: flex;
    align-items: center;
    padding-left: 10px;
  }
  .pager {
    text-align: center;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .menu {
    margin-bottom: 20px;
    .clear-item {
      margin-right: 25px;
    }
  }
  .search {
    display: flex;
    justify-content: left;
  }
  .filtrate_seek_sousuo1 {
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    cursor: pointer;
  }
  .filtrate_seek_sousuo1:hover {
    color: #0099ff;
  }

  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    // padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    text-align: center;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
  .cell {
    color: #606266 !important;
  }
}
</style>
